import * as React from "react";
import useProductName from "brand-customization/useProductName";
import { Link } from "components/common";
import { Alert } from "components/bootstrap";
import DocsHelper from "util/DocsHelper";
import LicenseHelp from "license/notifications/LicenseHelp";
const LicenseTrafficViolationNotification = ({ onDismissNotification }) => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(
    Alert,
    {
      bsStyle: "danger",
      className: "has-bm",
      onDismiss: () => onDismissNotification(),
      title: `${productName} License Violation Warning`
    },
    /* @__PURE__ */ React.createElement("p", null, "Your current traffic has exceeded your ", productName, " license traffic limitation. If traffic repeatedly exceeds the limit of the license,", " ", /* @__PURE__ */ React.createElement(Link, { to: DocsHelper.toString(DocsHelper.PAGES.LICENSE_MANAGEMENT) }, "some features will be turned off"), ".", " ", /* @__PURE__ */ React.createElement(LicenseHelp, null))
  );
};
export default LicenseTrafficViolationNotification;
